import React from "react";
import List from "../generic/List";
import { sortItemsByLabel } from "../../utils/CompareUtils";

interface MaterialListProps {
    title: string;
    items?: { id: number; label: string; public?: boolean }[];
    onEdit: (id: number | undefined, currentLabel: string) => void;
}

const MaterialList: React.FC<MaterialListProps> = ({ title, items = [], onEdit }) => {
    const sortedItems = sortItemsByLabel(items);
    return (
        <div className="w-1/2">
            <h2 className="text-lg font-semibold mb-4">{title}</h2>
            <List
                items={sortedItems}
                onEdit={(item) => onEdit(item.id, item.label)}
                onDelete={() => {
                }}
                renderItem={(item) => (
                    <>
                        <span>{item.label}</span>
                    </>
                )}
            />
        </div>
    );
};

export default MaterialList;